import styled from 'styled-components'

export const Container = styled.div``

export const InputContainer = styled.div`
  width: 330px;
`

export const IconsWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding-right: 20px;
`
